import { IsShadowMailboxUser } from "owa-mail-ads-shared/lib/sharedAdsUtils";
import { isPremiumConsumer } from "owa-session-store";
import { getGlobalSettingsAccountMailboxInfo } from "owa-account-source-list-store";

import isIndexedPath from "owa-url/lib/isIndexedPath";

/**
 * Check if its a Cloud cache scenario
 */
export function isCloudCacheScenario(): boolean {
    const mailboxInfo = getGlobalSettingsAccountMailboxInfo();
    return (isPremiumConsumer(mailboxInfo) || IsShadowMailboxUser(mailboxInfo)) && isIndexedPath();
}
